import React from 'react';

import { OrderDirection, PublishedDatasourceOrderField } from '../../../../../../gen-src/queries';
import { DefaultDirections, SortProviderProps, UrlSortProvider } from '../../../../data-catalog-shared';

export type DatasourcesValidSortFields =
  PublishedDatasourceOrderField.NAME |
  PublishedDatasourceOrderField.DOWNSTREAM_WORKBOOKS_COUNT |
  PublishedDatasourceOrderField.PROJECT_NAME |
  PublishedDatasourceOrderField.IS_CERTIFIED |
  PublishedDatasourceOrderField.CONTAINER_NAME;

export const DatasourcesDefaultDirections: DefaultDirections<DatasourcesValidSortFields> = {
  [PublishedDatasourceOrderField.NAME]: OrderDirection.ASC,
  [PublishedDatasourceOrderField.DOWNSTREAM_WORKBOOKS_COUNT]: OrderDirection.DESC,
  [PublishedDatasourceOrderField.PROJECT_NAME]: OrderDirection.ASC,
  [PublishedDatasourceOrderField.CONTAINER_NAME]: OrderDirection.ASC,
  [PublishedDatasourceOrderField.IS_CERTIFIED]: OrderDirection.DESC, // Certified items at the top
};

export const DatasourcesDefaultSortField = PublishedDatasourceOrderField.NAME;

export function DatasourcesGridSortProvider(
  props: Pick<SortProviderProps<DatasourcesValidSortFields>, 'children'>
): JSX.Element {
  return (
    <UrlSortProvider<DatasourcesValidSortFields>
      validOrderFieldsWithDefaultDirections={DatasourcesDefaultDirections}
      defaultField={DatasourcesDefaultSortField}
    >
      {props.children}
    </UrlSortProvider>
  );
}
